/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tag_Picker_Your_TagsInputs */



/**
* | output |
* | --- |
* | "Your tags" |
*
* @param {Project_Tag_Picker_Your_TagsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_picker_your_tags = /** @type {((inputs?: Project_Tag_Picker_Your_TagsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Picker_Your_TagsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Tags")
	return /** @type {LocalizedString} */ ("Your tags")
});